import { render, staticRenderFns } from "./EmployeeDocumentView.vue?vue&type=template&id=000ba848&"
import script from "./EmployeeDocumentView.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocumentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports